import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OverrideCode } from '../../classroom360/gradebook/v10/models/override-code.model';
import { Attachment } from '../../shared-components/models/attachment.model';
import { SharedService } from '../../shared-components/shared.service';
import { CourseSchedule } from '../../shared-components/student/course-schedule.model';
import { StudentService } from '../../shared-components/student/student.service';
import { System } from '../../shared-components/System';
import { AssignmentFilterParam } from './assignment-filter-param';
import { AssignmentsDTO, GradeBookStandards } from './assignment.model';

@Injectable({
    providedIn: 'root'
})
export class AssignmentService {

    selectedCourse: CourseSchedule;
    selectedSectionId = -1;
    selectedGP: string;
    studentAssignmentsUPMG: AssignmentsDTO[] = [];
    preventTabSwitch: boolean;
    ShowByClass = true;
    filterParam: AssignmentFilterParam;
    filterChange = new EventEmitter<any>();
    filterbyCard = false;
    selectedCoursebyCard: string;
    viewOptions = [
        { name: 'Today\'s Only', value: '1' },
        { name: 'This Term', value: '2' },
        { name: 'All', value: '3' }
    ];
    selectedCourseSection: string;
    selectedView: number;

    constructor(
        private http: HttpClient,
        private studentService: StudentService,
        private sharedService: SharedService
    ) {
    }

    getStudentAssignments(studentId: number, yearId: number, siteSectionID: number, startDate: Date, endDate: Date, termId: number, SiteYearId: number): Observable<AssignmentsDTO[]> {
        const queryString = '?studentId=' + studentId +
            '&yearId=' + yearId +
            '&siteSectionID=' + siteSectionID +
            '&startDate=' + startDate +
            '&endDate=' + endDate +
            '&TermId=' + termId +
            '&SiteYearId=' + SiteYearId;
        return this.http.get<AssignmentsDTO[]>(System.apiURL.Student + 'GetStudentAssignments' + queryString);
    }


    getStudentAttachment(studentId: number, yearId: number, siteSectionID: number, startDate: Date, endDate: Date, termId: number, SiteYearId: number): Observable<Attachment[]> {
        const queryString = '?studentId=' + studentId +
            '&yearId=' + yearId +
            '&siteSectionID=' + siteSectionID +
            '&startDate=' + startDate +
            '&endDate=' + endDate +
            '&TermId=' + termId +
            '&SiteYearId=' + SiteYearId;
        return this.http.get<Attachment[]>(System.apiURL.Student + 'GetStudentAttachment' + queryString);
    }

    getTermsFromUPComingAssignments() {
        let matches: any = [];
        const reducer = (array, item) => array.concat(item['Term']);
        matches = this.studentAssignmentsUPMG.reduce(reducer, []);
        // to get unique values
        return Array.from(new Set(matches));
    }

    getCoursesFromUPComingAssignments() {
        let matches: any = [];
        const reducer = (array, item) => array.concat(item['Course']);
        matches = this.studentAssignmentsUPMG.reduce(reducer, []);
        // to get unique values
        return Array.from(new Set(matches));
    }

    getStandardsBasedHeader(siteSectionId: number, startDate: Date, endDate: Date, termId: number): Observable<GradeBookStandards[]> {
        const queryString = '?siteSectionId=' + siteSectionId +
            '&startDate=' + startDate +
            '&endDate=' + endDate +
            '&TermId=' + termId;
        return this.http.get<GradeBookStandards[]>(System.apiURL.Student + 'GetStandardsBasedHeader' + queryString);
    }

    getCategories(isTeacherUser: boolean, courseId: number, courseIds: string): Observable<any> {
        return this.sharedService.getCategories(isTeacherUser, courseId, courseIds);
    }

    getOverrideCodes() {
        return this.http.get<OverrideCode[]>(System.apiURL.Student + 'GetGradeOverrideCodes?yearId=' + this.studentService.studentEnrollment.SiteYearId + '&schoolId=' + this.studentService.studentEnrollment.SchoolId);
    }
}
